/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnalyzeLoyaltyPortfolioRequest,
  AnalyzeLoyaltyPortfolioResponse,
  BookTimeThreeDsGateRequest,
  BookTimeThreeDsGateResponse,
  CancelPaymentAuthorizationRequest,
  CancelPaymentAuthorizationResponse,
  CapturePaymentRequest,
  CapturePaymentResponse,
  ChargePaymentMethodRequest,
  ChargePaymentMethodResponse,
  EnsureFirstPartyMcpGrantRequest,
  EnsureFirstPartyMcpGrantResponse,
  GetOauthGrantRequest,
  GetOauthGrantResponse,
  HTTPForbiddenError,
  HTTPUnauthorizedError,
  HTTPValidationError,
  LatestHotelEmailRequest,
  LatestHotelEmailResponse,
  NotFoundError,
  RefundPaymentRequest,
  RefundPaymentResponse,
  SetCashbackTierRequest,
  SetCashbackTierResponse,
  SuccessResponse,
  SupportAddRewardLedgerEntryRequest,
  SupportRecomputeReferralCreditsRequest,
  SupportRecomputeReferralCreditsResponse,
  SupportRewardLedgerMutationResponse,
  SupportSetReferralOriginRequest,
  SupportUpdateRewardLedgerEntryRequest,
  SupportUserRewardContextRequest,
  SupportUserRewardContextResponse,
  UserByEmailRequest,
  UserByEmailResponse,
} from '../models/index';
import {
    AnalyzeLoyaltyPortfolioRequestFromJSON,
    AnalyzeLoyaltyPortfolioRequestToJSON,
    AnalyzeLoyaltyPortfolioResponseFromJSON,
    AnalyzeLoyaltyPortfolioResponseToJSON,
    BookTimeThreeDsGateRequestFromJSON,
    BookTimeThreeDsGateRequestToJSON,
    BookTimeThreeDsGateResponseFromJSON,
    BookTimeThreeDsGateResponseToJSON,
    CancelPaymentAuthorizationRequestFromJSON,
    CancelPaymentAuthorizationRequestToJSON,
    CancelPaymentAuthorizationResponseFromJSON,
    CancelPaymentAuthorizationResponseToJSON,
    CapturePaymentRequestFromJSON,
    CapturePaymentRequestToJSON,
    CapturePaymentResponseFromJSON,
    CapturePaymentResponseToJSON,
    ChargePaymentMethodRequestFromJSON,
    ChargePaymentMethodRequestToJSON,
    ChargePaymentMethodResponseFromJSON,
    ChargePaymentMethodResponseToJSON,
    EnsureFirstPartyMcpGrantRequestFromJSON,
    EnsureFirstPartyMcpGrantRequestToJSON,
    EnsureFirstPartyMcpGrantResponseFromJSON,
    EnsureFirstPartyMcpGrantResponseToJSON,
    GetOauthGrantRequestFromJSON,
    GetOauthGrantRequestToJSON,
    GetOauthGrantResponseFromJSON,
    GetOauthGrantResponseToJSON,
    HTTPForbiddenErrorFromJSON,
    HTTPForbiddenErrorToJSON,
    HTTPUnauthorizedErrorFromJSON,
    HTTPUnauthorizedErrorToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    LatestHotelEmailRequestFromJSON,
    LatestHotelEmailRequestToJSON,
    LatestHotelEmailResponseFromJSON,
    LatestHotelEmailResponseToJSON,
    NotFoundErrorFromJSON,
    NotFoundErrorToJSON,
    RefundPaymentRequestFromJSON,
    RefundPaymentRequestToJSON,
    RefundPaymentResponseFromJSON,
    RefundPaymentResponseToJSON,
    SetCashbackTierRequestFromJSON,
    SetCashbackTierRequestToJSON,
    SetCashbackTierResponseFromJSON,
    SetCashbackTierResponseToJSON,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
    SupportAddRewardLedgerEntryRequestFromJSON,
    SupportAddRewardLedgerEntryRequestToJSON,
    SupportRecomputeReferralCreditsRequestFromJSON,
    SupportRecomputeReferralCreditsRequestToJSON,
    SupportRecomputeReferralCreditsResponseFromJSON,
    SupportRecomputeReferralCreditsResponseToJSON,
    SupportRewardLedgerMutationResponseFromJSON,
    SupportRewardLedgerMutationResponseToJSON,
    SupportSetReferralOriginRequestFromJSON,
    SupportSetReferralOriginRequestToJSON,
    SupportUpdateRewardLedgerEntryRequestFromJSON,
    SupportUpdateRewardLedgerEntryRequestToJSON,
    SupportUserRewardContextRequestFromJSON,
    SupportUserRewardContextRequestToJSON,
    SupportUserRewardContextResponseFromJSON,
    SupportUserRewardContextResponseToJSON,
    UserByEmailRequestFromJSON,
    UserByEmailRequestToJSON,
    UserByEmailResponseFromJSON,
    UserByEmailResponseToJSON,
} from '../models/index';

export interface V2InternalAnalyzeLoyaltyPortfolioPostRequest {
    analyzeLoyaltyPortfolioRequest: AnalyzeLoyaltyPortfolioRequest;
}

export interface V2InternalBookTimeThreeDsGatePostRequest {
    bookTimeThreeDsGateRequest: BookTimeThreeDsGateRequest;
}

export interface V2InternalBookingRewardsBookingTypeBookingIdCancelPutRequest {
    bookingType: V2InternalBookingRewardsBookingTypeBookingIdCancelPutBookingTypeEnum;
    bookingId: number;
    userId: string;
}

export interface V2InternalCancelPaymentAuthorizationPostRequest {
    cancelPaymentAuthorizationRequest: CancelPaymentAuthorizationRequest;
}

export interface V2InternalCapturePaymentPostRequest {
    capturePaymentRequest: CapturePaymentRequest;
}

export interface V2InternalChargePaymentMethodPostRequest {
    chargePaymentMethodRequest: ChargePaymentMethodRequest;
}

export interface V2InternalEnsureFirstPartyMcpGrantPostRequest {
    ensureFirstPartyMcpGrantRequest: EnsureFirstPartyMcpGrantRequest;
}

export interface V2InternalGetOauthGrantPostRequest {
    getOauthGrantRequest: GetOauthGrantRequest;
}

export interface V2InternalInboxLatestHotelEmailPostRequest {
    latestHotelEmailRequest: LatestHotelEmailRequest;
}

export interface V2InternalPaymentIntentsPaymentIntentIdGetRequest {
    paymentIntentId: string;
    test?: boolean;
}

export interface V2InternalRefundPaymentPostRequest {
    refundPaymentRequest: RefundPaymentRequest;
}

export interface V2InternalSetCashbackTierPostRequest {
    setCashbackTierRequest: SetCashbackTierRequest;
}

export interface V2InternalSupportReferralCreditsRecomputePostRequest {
    supportRecomputeReferralCreditsRequest: SupportRecomputeReferralCreditsRequest;
}

export interface V2InternalSupportReferralOriginPostRequest {
    supportSetReferralOriginRequest: SupportSetReferralOriginRequest;
}

export interface V2InternalSupportRewardLedgerAddPostRequest {
    supportAddRewardLedgerEntryRequest: SupportAddRewardLedgerEntryRequest;
}

export interface V2InternalSupportRewardLedgerUpdatePostRequest {
    supportUpdateRewardLedgerEntryRequest: SupportUpdateRewardLedgerEntryRequest;
}

export interface V2InternalSupportUserRewardContextPostRequest {
    supportUserRewardContextRequest: SupportUserRewardContextRequest;
}

export interface V2InternalUserByEmailPostRequest {
    userByEmailRequest: UserByEmailRequest;
}

/**
 * 
 */
export class InternalApi extends runtime.BaseAPI {

    /**
     * Analyze a user\'s loyalty portfolio using the canonical Python loyalty-program registry. This keeps transfer partners and ratios in one place while allowing the Go MCP runtime to render the same portfolio recommendations as the Python MCP runtime. Requires a service-principal JWT; user tokens are rejected with 403. 
     */
    async v2InternalAnalyzeLoyaltyPortfolioPostRaw(requestParameters: V2InternalAnalyzeLoyaltyPortfolioPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnalyzeLoyaltyPortfolioResponse>> {
        if (requestParameters['analyzeLoyaltyPortfolioRequest'] == null) {
            throw new runtime.RequiredError(
                'analyzeLoyaltyPortfolioRequest',
                'Required parameter "analyzeLoyaltyPortfolioRequest" was null or undefined when calling v2InternalAnalyzeLoyaltyPortfolioPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/analyze_loyalty_portfolio`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnalyzeLoyaltyPortfolioRequestToJSON(requestParameters['analyzeLoyaltyPortfolioRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnalyzeLoyaltyPortfolioResponseFromJSON(jsonValue));
    }

    /**
     * Analyze a user\'s loyalty portfolio using the canonical Python loyalty-program registry. This keeps transfer partners and ratios in one place while allowing the Go MCP runtime to render the same portfolio recommendations as the Python MCP runtime. Requires a service-principal JWT; user tokens are rejected with 403. 
     */
    async v2InternalAnalyzeLoyaltyPortfolioPost(requestParameters: V2InternalAnalyzeLoyaltyPortfolioPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnalyzeLoyaltyPortfolioResponse> {
        const response = await this.v2InternalAnalyzeLoyaltyPortfolioPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Book-time 3DS backstop for cards that skipped add-time 3DS (GON-6638). Card adds flagged `auto_save` are exempt from add-time 3DS (auto-save onboarding), which would otherwise let a fraudster opt out by setting a client-supplied flag — so api_search calls this from the user-initiated booking flow and the identical 3DS wall appears the moment they try to book. The decision is made entirely from data this service owns (the payment_methods fraud columns and the owning user row); a card with no prior 3DS record triggers a fresh server-side 3DS-requested SetupIntent when the account is <24h old, or at any account age when the caller sets `require_three_ds` (LiteAPI-backed bookings, where Gondola is merchant of record). Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalBookTimeThreeDsGatePostRaw(requestParameters: V2InternalBookTimeThreeDsGatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BookTimeThreeDsGateResponse>> {
        if (requestParameters['bookTimeThreeDsGateRequest'] == null) {
            throw new runtime.RequiredError(
                'bookTimeThreeDsGateRequest',
                'Required parameter "bookTimeThreeDsGateRequest" was null or undefined when calling v2InternalBookTimeThreeDsGatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/book_time_three_ds_gate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookTimeThreeDsGateRequestToJSON(requestParameters['bookTimeThreeDsGateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookTimeThreeDsGateResponseFromJSON(jsonValue));
    }

    /**
     * Book-time 3DS backstop for cards that skipped add-time 3DS (GON-6638). Card adds flagged `auto_save` are exempt from add-time 3DS (auto-save onboarding), which would otherwise let a fraudster opt out by setting a client-supplied flag — so api_search calls this from the user-initiated booking flow and the identical 3DS wall appears the moment they try to book. The decision is made entirely from data this service owns (the payment_methods fraud columns and the owning user row); a card with no prior 3DS record triggers a fresh server-side 3DS-requested SetupIntent when the account is <24h old, or at any account age when the caller sets `require_three_ds` (LiteAPI-backed bookings, where Gondola is merchant of record). Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalBookTimeThreeDsGatePost(requestParameters: V2InternalBookTimeThreeDsGatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BookTimeThreeDsGateResponse> {
        const response = await this.v2InternalBookTimeThreeDsGatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Durably tombstone booking rewards even when the asynchronous trip projection does not exist yet.
     */
    async v2InternalBookingRewardsBookingTypeBookingIdCancelPutRaw(requestParameters: V2InternalBookingRewardsBookingTypeBookingIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters['bookingType'] == null) {
            throw new runtime.RequiredError(
                'bookingType',
                'Required parameter "bookingType" was null or undefined when calling v2InternalBookingRewardsBookingTypeBookingIdCancelPut().'
            );
        }

        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling v2InternalBookingRewardsBookingTypeBookingIdCancelPut().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling v2InternalBookingRewardsBookingTypeBookingIdCancelPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/booking_rewards/{booking_type}/{booking_id}/cancel`;
        urlPath = urlPath.replace(`{${"booking_type"}}`, encodeURIComponent(String(requestParameters['bookingType'])));
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Durably tombstone booking rewards even when the asynchronous trip projection does not exist yet.
     */
    async v2InternalBookingRewardsBookingTypeBookingIdCancelPut(requestParameters: V2InternalBookingRewardsBookingTypeBookingIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessResponse> {
        const response = await this.v2InternalBookingRewardsBookingTypeBookingIdCancelPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel an uncaptured Stripe PaymentIntent authorization. Used when a LiteAPI supplier booking fails after card authorization but before capture. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalCancelPaymentAuthorizationPostRaw(requestParameters: V2InternalCancelPaymentAuthorizationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelPaymentAuthorizationResponse>> {
        if (requestParameters['cancelPaymentAuthorizationRequest'] == null) {
            throw new runtime.RequiredError(
                'cancelPaymentAuthorizationRequest',
                'Required parameter "cancelPaymentAuthorizationRequest" was null or undefined when calling v2InternalCancelPaymentAuthorizationPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/cancel_payment_authorization`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelPaymentAuthorizationRequestToJSON(requestParameters['cancelPaymentAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelPaymentAuthorizationResponseFromJSON(jsonValue));
    }

    /**
     * Cancel an uncaptured Stripe PaymentIntent authorization. Used when a LiteAPI supplier booking fails after card authorization but before capture. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalCancelPaymentAuthorizationPost(requestParameters: V2InternalCancelPaymentAuthorizationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelPaymentAuthorizationResponse> {
        const response = await this.v2InternalCancelPaymentAuthorizationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Capture a previously authorized Stripe PaymentIntent. Used by LiteAPI card-on-book after the supplier booking succeeds, so customer funds are only captured after inventory is confirmed. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalCapturePaymentPostRaw(requestParameters: V2InternalCapturePaymentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CapturePaymentResponse>> {
        if (requestParameters['capturePaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'capturePaymentRequest',
                'Required parameter "capturePaymentRequest" was null or undefined when calling v2InternalCapturePaymentPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/capture_payment`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CapturePaymentRequestToJSON(requestParameters['capturePaymentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CapturePaymentResponseFromJSON(jsonValue));
    }

    /**
     * Capture a previously authorized Stripe PaymentIntent. Used by LiteAPI card-on-book after the supplier booking succeeds, so customer funds are only captured after inventory is confirmed. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalCapturePaymentPost(requestParameters: V2InternalCapturePaymentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CapturePaymentResponse> {
        const response = await this.v2InternalCapturePaymentPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Off-session Stripe charge against a saved PaymentMethod (GON-5897 phase 3). Looks up the Gondola PaymentMethod, gets-or-creates the user\'s Stripe Customer, and charges via `CardFraudValidator.charge_saved_card`. Internal service-to-service endpoint — api_search calls this from the LiteAPI book flow when the user\'s Gondola Cash balance doesn\'t cover the booking. The response carries the PaymentIntent id + final status so the caller can persist it on the booking row and decide whether to proceed with supplier book-out (`succeeded`), surface a 3DS challenge (`requires_action`), or abort (`declined`). Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalChargePaymentMethodPostRaw(requestParameters: V2InternalChargePaymentMethodPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChargePaymentMethodResponse>> {
        if (requestParameters['chargePaymentMethodRequest'] == null) {
            throw new runtime.RequiredError(
                'chargePaymentMethodRequest',
                'Required parameter "chargePaymentMethodRequest" was null or undefined when calling v2InternalChargePaymentMethodPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/charge_payment_method`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChargePaymentMethodRequestToJSON(requestParameters['chargePaymentMethodRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChargePaymentMethodResponseFromJSON(jsonValue));
    }

    /**
     * Off-session Stripe charge against a saved PaymentMethod (GON-5897 phase 3). Looks up the Gondola PaymentMethod, gets-or-creates the user\'s Stripe Customer, and charges via `CardFraudValidator.charge_saved_card`. Internal service-to-service endpoint — api_search calls this from the LiteAPI book flow when the user\'s Gondola Cash balance doesn\'t cover the booking. The response carries the PaymentIntent id + final status so the caller can persist it on the booking row and decide whether to proceed with supplier book-out (`succeeded`), surface a 3DS challenge (`requires_action`), or abort (`declined`). Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalChargePaymentMethodPost(requestParameters: V2InternalChargePaymentMethodPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChargePaymentMethodResponse> {
        const response = await this.v2InternalChargePaymentMethodPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ensure a first-party Gondola MCP OAuth client and active grant exist for a user. Intended for Gondola-owned product surfaces, such as Chat, that are already behind Gondola authentication and need to call the public MCP server as a normal OAuth client. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalEnsureFirstPartyMcpGrantPostRaw(requestParameters: V2InternalEnsureFirstPartyMcpGrantPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnsureFirstPartyMcpGrantResponse>> {
        if (requestParameters['ensureFirstPartyMcpGrantRequest'] == null) {
            throw new runtime.RequiredError(
                'ensureFirstPartyMcpGrantRequest',
                'Required parameter "ensureFirstPartyMcpGrantRequest" was null or undefined when calling v2InternalEnsureFirstPartyMcpGrantPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/ensure_first_party_mcp_grant`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EnsureFirstPartyMcpGrantRequestToJSON(requestParameters['ensureFirstPartyMcpGrantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnsureFirstPartyMcpGrantResponseFromJSON(jsonValue));
    }

    /**
     * Ensure a first-party Gondola MCP OAuth client and active grant exist for a user. Intended for Gondola-owned product surfaces, such as Chat, that are already behind Gondola authentication and need to call the public MCP server as a normal OAuth client. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalEnsureFirstPartyMcpGrantPost(requestParameters: V2InternalEnsureFirstPartyMcpGrantPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnsureFirstPartyMcpGrantResponse> {
        const response = await this.v2InternalEnsureFirstPartyMcpGrantPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Look up the oauth_grants row for (user_id, client_id). Returns the staleness floor (`tokens_valid_from`) and revocation state so api_mcp can reject stale or revoked access-token JWTs. Internal service-to-service endpoint. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalGetOauthGrantPostRaw(requestParameters: V2InternalGetOauthGrantPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOauthGrantResponse>> {
        if (requestParameters['getOauthGrantRequest'] == null) {
            throw new runtime.RequiredError(
                'getOauthGrantRequest',
                'Required parameter "getOauthGrantRequest" was null or undefined when calling v2InternalGetOauthGrantPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/get_oauth_grant`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetOauthGrantRequestToJSON(requestParameters['getOauthGrantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOauthGrantResponseFromJSON(jsonValue));
    }

    /**
     * Look up the oauth_grants row for (user_id, client_id). Returns the staleness floor (`tokens_valid_from`) and revocation state so api_mcp can reject stale or revoked access-token JWTs. Internal service-to-service endpoint. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalGetOauthGrantPost(requestParameters: V2InternalGetOauthGrantPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOauthGrantResponse> {
        const response = await this.v2InternalGetOauthGrantPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return the most recent email from any known hotel sender in a user\'s connected inbox, for the support portal\'s \"fetch supplier email\" action (an operator completing a points booking by hand needs the loyalty program\'s most recent verification/2FA email). Internal service-to-service endpoint; requires a service-principal JWT (`sub` = `service:<name>`). User tokens are rejected with 403. The body is returned but never logged. 
     */
    async v2InternalInboxLatestHotelEmailPostRaw(requestParameters: V2InternalInboxLatestHotelEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LatestHotelEmailResponse>> {
        if (requestParameters['latestHotelEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'latestHotelEmailRequest',
                'Required parameter "latestHotelEmailRequest" was null or undefined when calling v2InternalInboxLatestHotelEmailPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/inbox/latest_hotel_email`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LatestHotelEmailRequestToJSON(requestParameters['latestHotelEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LatestHotelEmailResponseFromJSON(jsonValue));
    }

    /**
     * Return the most recent email from any known hotel sender in a user\'s connected inbox, for the support portal\'s \"fetch supplier email\" action (an operator completing a points booking by hand needs the loyalty program\'s most recent verification/2FA email). Internal service-to-service endpoint; requires a service-principal JWT (`sub` = `service:<name>`). User tokens are rejected with 403. The body is returned but never logged. 
     */
    async v2InternalInboxLatestHotelEmailPost(requestParameters: V2InternalInboxLatestHotelEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LatestHotelEmailResponse> {
        const response = await this.v2InternalInboxLatestHotelEmailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve Stripe\'s authoritative PaymentIntent status for durable capture reconciliation.
     */
    async v2InternalPaymentIntentsPaymentIntentIdGetRaw(requestParameters: V2InternalPaymentIntentsPaymentIntentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CapturePaymentResponse>> {
        if (requestParameters['paymentIntentId'] == null) {
            throw new runtime.RequiredError(
                'paymentIntentId',
                'Required parameter "paymentIntentId" was null or undefined when calling v2InternalPaymentIntentsPaymentIntentIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/payment_intents/{payment_intent_id}`;
        urlPath = urlPath.replace(`{${"payment_intent_id"}}`, encodeURIComponent(String(requestParameters['paymentIntentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CapturePaymentResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve Stripe\'s authoritative PaymentIntent status for durable capture reconciliation.
     */
    async v2InternalPaymentIntentsPaymentIntentIdGet(requestParameters: V2InternalPaymentIntentsPaymentIntentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CapturePaymentResponse> {
        const response = await this.v2InternalPaymentIntentsPaymentIntentIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Issue a Stripe refund against a captured PaymentIntent (GON-6115). Internal service-to-service endpoint — api_search calls this from the LiteAPI cancel / orphan-charge / supplier-failure refund paths. The Stripe secret lives here (mirrors `/v2/internal/charge_payment_method`), so api_search never needs its own `STRIPE_SECRET_KEY`. The amount is supplied in minor units (cents); the caller is responsible for computing it from the cancellation policy and for the zero-decimal-currency guard. The response carries the refund id + final status so the caller can persist `stripe_refund_id` / `refunded_amount` on the booking row. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalRefundPaymentPostRaw(requestParameters: V2InternalRefundPaymentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefundPaymentResponse>> {
        if (requestParameters['refundPaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'refundPaymentRequest',
                'Required parameter "refundPaymentRequest" was null or undefined when calling v2InternalRefundPaymentPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/refund_payment`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefundPaymentRequestToJSON(requestParameters['refundPaymentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefundPaymentResponseFromJSON(jsonValue));
    }

    /**
     * Issue a Stripe refund against a captured PaymentIntent (GON-6115). Internal service-to-service endpoint — api_search calls this from the LiteAPI cancel / orphan-charge / supplier-failure refund paths. The Stripe secret lives here (mirrors `/v2/internal/charge_payment_method`), so api_search never needs its own `STRIPE_SECRET_KEY`. The amount is supplied in minor units (cents); the caller is responsible for computing it from the cancellation policy and for the zero-decimal-currency guard. The response carries the refund id + final status so the caller can persist `stripe_refund_id` / `refunded_amount` on the booking row. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalRefundPaymentPost(requestParameters: V2InternalRefundPaymentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefundPaymentResponse> {
        const response = await this.v2InternalRefundPaymentPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set a user\'s cashback tier durably, for the support portal\'s set-tier action. A bare `users.cashback_percentage_tier` write does not stick: while a status challenge is attached, the `manage_active_status_challenge` cron overwrites the tier on expiry. This endpoint sets the tier AND detaches (expires) any active status challenge so the grant survives, mirroring `enroll_gondola_gold.py`. Internal service-to-service endpoint. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalSetCashbackTierPostRaw(requestParameters: V2InternalSetCashbackTierPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetCashbackTierResponse>> {
        if (requestParameters['setCashbackTierRequest'] == null) {
            throw new runtime.RequiredError(
                'setCashbackTierRequest',
                'Required parameter "setCashbackTierRequest" was null or undefined when calling v2InternalSetCashbackTierPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/set_cashback_tier`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetCashbackTierRequestToJSON(requestParameters['setCashbackTierRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetCashbackTierResponseFromJSON(jsonValue));
    }

    /**
     * Set a user\'s cashback tier durably, for the support portal\'s set-tier action. A bare `users.cashback_percentage_tier` write does not stick: while a status challenge is attached, the `manage_active_status_challenge` cron overwrites the tier on expiry. This endpoint sets the tier AND detaches (expires) any active status challenge so the grant survives, mirroring `enroll_gondola_gold.py`. Internal service-to-service endpoint. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalSetCashbackTierPost(requestParameters: V2InternalSetCashbackTierPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetCashbackTierResponse> {
        const response = await this.v2InternalSetCashbackTierPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Re-run the standard referral-credit pipeline for all qualifying Gondola bookings. Service-principal only.
     */
    async v2InternalSupportReferralCreditsRecomputePostRaw(requestParameters: V2InternalSupportReferralCreditsRecomputePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportRecomputeReferralCreditsResponse>> {
        if (requestParameters['supportRecomputeReferralCreditsRequest'] == null) {
            throw new runtime.RequiredError(
                'supportRecomputeReferralCreditsRequest',
                'Required parameter "supportRecomputeReferralCreditsRequest" was null or undefined when calling v2InternalSupportReferralCreditsRecomputePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/support/referral_credits/recompute`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRecomputeReferralCreditsRequestToJSON(requestParameters['supportRecomputeReferralCreditsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportRecomputeReferralCreditsResponseFromJSON(jsonValue));
    }

    /**
     * Re-run the standard referral-credit pipeline for all qualifying Gondola bookings. Service-principal only.
     */
    async v2InternalSupportReferralCreditsRecomputePost(requestParameters: V2InternalSupportReferralCreditsRecomputePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportRecomputeReferralCreditsResponse> {
        const response = await this.v2InternalSupportReferralCreditsRecomputePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace or clear a user\'s referring user/promotion. Service-principal only.
     */
    async v2InternalSupportReferralOriginPostRaw(requestParameters: V2InternalSupportReferralOriginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportUserRewardContextResponse>> {
        if (requestParameters['supportSetReferralOriginRequest'] == null) {
            throw new runtime.RequiredError(
                'supportSetReferralOriginRequest',
                'Required parameter "supportSetReferralOriginRequest" was null or undefined when calling v2InternalSupportReferralOriginPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/support/referral_origin`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportSetReferralOriginRequestToJSON(requestParameters['supportSetReferralOriginRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportUserRewardContextResponseFromJSON(jsonValue));
    }

    /**
     * Replace or clear a user\'s referring user/promotion. Service-principal only.
     */
    async v2InternalSupportReferralOriginPost(requestParameters: V2InternalSupportReferralOriginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportUserRewardContextResponse> {
        const response = await this.v2InternalSupportReferralOriginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a manual support-credit ledger entry. Service-principal only.
     */
    async v2InternalSupportRewardLedgerAddPostRaw(requestParameters: V2InternalSupportRewardLedgerAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportRewardLedgerMutationResponse>> {
        if (requestParameters['supportAddRewardLedgerEntryRequest'] == null) {
            throw new runtime.RequiredError(
                'supportAddRewardLedgerEntryRequest',
                'Required parameter "supportAddRewardLedgerEntryRequest" was null or undefined when calling v2InternalSupportRewardLedgerAddPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/support/reward_ledger/add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAddRewardLedgerEntryRequestToJSON(requestParameters['supportAddRewardLedgerEntryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportRewardLedgerMutationResponseFromJSON(jsonValue));
    }

    /**
     * Add a manual support-credit ledger entry. Service-principal only.
     */
    async v2InternalSupportRewardLedgerAddPost(requestParameters: V2InternalSupportRewardLedgerAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportRewardLedgerMutationResponse> {
        const response = await this.v2InternalSupportRewardLedgerAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update amount/pending on a user-owned reward-ledger row. Service-principal only.
     */
    async v2InternalSupportRewardLedgerUpdatePostRaw(requestParameters: V2InternalSupportRewardLedgerUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportRewardLedgerMutationResponse>> {
        if (requestParameters['supportUpdateRewardLedgerEntryRequest'] == null) {
            throw new runtime.RequiredError(
                'supportUpdateRewardLedgerEntryRequest',
                'Required parameter "supportUpdateRewardLedgerEntryRequest" was null or undefined when calling v2InternalSupportRewardLedgerUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/support/reward_ledger/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateRewardLedgerEntryRequestToJSON(requestParameters['supportUpdateRewardLedgerEntryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportRewardLedgerMutationResponseFromJSON(jsonValue));
    }

    /**
     * Update amount/pending on a user-owned reward-ledger row. Service-principal only.
     */
    async v2InternalSupportRewardLedgerUpdatePost(requestParameters: V2InternalSupportRewardLedgerUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportRewardLedgerMutationResponse> {
        const response = await this.v2InternalSupportRewardLedgerUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return the support-only referral/promotion context for a user.
     */
    async v2InternalSupportUserRewardContextPostRaw(requestParameters: V2InternalSupportUserRewardContextPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportUserRewardContextResponse>> {
        if (requestParameters['supportUserRewardContextRequest'] == null) {
            throw new runtime.RequiredError(
                'supportUserRewardContextRequest',
                'Required parameter "supportUserRewardContextRequest" was null or undefined when calling v2InternalSupportUserRewardContextPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/support/user_reward_context`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUserRewardContextRequestToJSON(requestParameters['supportUserRewardContextRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportUserRewardContextResponseFromJSON(jsonValue));
    }

    /**
     * Return the support-only referral/promotion context for a user.
     */
    async v2InternalSupportUserRewardContextPost(requestParameters: V2InternalSupportUserRewardContextPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportUserRewardContextResponse> {
        const response = await this.v2InternalSupportUserRewardContextPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a user\'s id from their email (case-insensitive), for the support portal\'s lookup-by-email. Read-only: returns only the id, so the portal can then read the full profile through the ordinary user endpoints. Internal service-to-service endpoint. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalUserByEmailPostRaw(requestParameters: V2InternalUserByEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserByEmailResponse>> {
        if (requestParameters['userByEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'userByEmailRequest',
                'Required parameter "userByEmailRequest" was null or undefined when calling v2InternalUserByEmailPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/internal/user_by_email`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserByEmailRequestToJSON(requestParameters['userByEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserByEmailResponseFromJSON(jsonValue));
    }

    /**
     * Resolve a user\'s id from their email (case-insensitive), for the support portal\'s lookup-by-email. Read-only: returns only the id, so the portal can then read the full profile through the ordinary user endpoints. Internal service-to-service endpoint. Requires a service-principal JWT (`sub` = `service:<name>`, minted via `common.auth.create_service_token`). User tokens are rejected with 403. 
     */
    async v2InternalUserByEmailPost(requestParameters: V2InternalUserByEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserByEmailResponse> {
        const response = await this.v2InternalUserByEmailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const V2InternalBookingRewardsBookingTypeBookingIdCancelPutBookingTypeEnum = {
    Hotel: 'hotel',
    Vehicle: 'vehicle'
} as const;
export type V2InternalBookingRewardsBookingTypeBookingIdCancelPutBookingTypeEnum = typeof V2InternalBookingRewardsBookingTypeBookingIdCancelPutBookingTypeEnum[keyof typeof V2InternalBookingRewardsBookingTypeBookingIdCancelPutBookingTypeEnum];
